<template>
    <div>
        <Pane />

        <a-card class="container">
            <a-form
                    :form="form"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 12 }"
                    :colon="false"
                    @submit="handleSubmit"
            >
                <a-row>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span class="required" slot="label">主要负责人</span>
                            <div>
                                <EmployeeSelector
                                        @change="chargerChange"
                                        :value="chargeUser.name ? [chargeUser] : []"
                                >
                                    <a-button block style="text-align: left">
                                        <div v-if="chargeUser.name">{{ chargeUser.name }}</div>
                                        <div v-else>&nbsp;</div>
                                    </a-button>
                                </EmployeeSelector>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="所属部门">
                            <a-select
                                    :disabled='true'
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    v-decorator="[
                  'deptId',
                ]"
                                    style="width: 100%"
                                    placeholder
                            >
                                <a-select-option
                                        v-for="item in productionDepartmentList"
                                        :key="item.id"
                                        :value="item.id"
                                >
                                    {{
                                    item.uniqueName }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span slot="label" class="required">商务对接人</span>
                            <div>
                                <EmployeeSelector
                                        @change="(arr) => {
                    if (arr.length) {
                      businessUser = arr[0];
                    } else {
                      businessUser = {};
                    }
                  }
                    "
                                        :value="businessUser.name ? [businessUser] : []"
                                >
                                    <a-button block style="text-align: left">
                                        <div v-if="businessUser.name">{{ businessUser.name }}</div>
                                        <div v-else>&nbsp;</div>
                                    </a-button>
                                </EmployeeSelector>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span slot="label" class="required">技术对接人</span>
                            <div>
                                <EmployeeSelector
                                        @change="(arr) => {
                    if (arr.length) {
                      technologyUser = arr[0];
                    } else {
                      technologyUser = {};
                    }
                  }
                    "
                                        :value="technologyUser.name ? [technologyUser] : []"
                                >
                                    <a-button block style="text-align: left">
                                        <div v-if="technologyUser.name">{{ technologyUser.name }}</div>
                                        <div v-else>&nbsp;</div>
                                    </a-button>
                                </EmployeeSelector>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="24" :md="24" :sm="24">
                        <a-form-item label="申请说明" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                            <a-textarea
                                    v-decorator="[
                  'remark',
                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="申报地市">
                            <a-cascader
                                    @change="locationChange"
                                    placeholder
                                    v-decorator="[
                  'location',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    :options="cityList"
                                    :fieldNames="{
                  label: 'name',
                  value: 'name',
                  children: 'children',
                }"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span slot="label">所属区域</span>
                            <a-cascader
                                    popup-class-name="area-cascader"
                                    placeholder=""
                                    v-decorator="[
                'area',
                { rules: [{ required: true, message: '请选择！' }] },
              ]"
                                    :options="areaList"
                                    :fieldNames="{
                label: 'areaName',
                value: 'key',
                children: 'children',
              }"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="24" :md="24" :sm="24">
                        <a-form-item label="客户关系" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                            <a-checkbox-group
                                    v-decorator="[
                  'customerRelationship',
                ]"
                            >
                                <a-checkbox
                                        v-for="item in ['高层互访','中层资源', '基层对接']"
                                        :key="item"
                                        :value="item"
                                >
                                    {{ item }}
                                </a-checkbox>
                            </a-checkbox-group>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span slot="label" class>互访带队领导</span>
                            <div>
                                <EmployeeSelector
                                        @change="(arr) => {
                      if (arr.length) {
                        visitLeader = arr[0];
                      } else {
                        visitLeader = {};
                      }
                    }
                      "
                                        :value="visitLeader.name ? [visitLeader] : []"
                                >
                                    <a-button block style="text-align: left">
                                        <div v-if="visitLeader.name">{{ visitLeader.name }}</div>
                                        <div v-else>&nbsp;</div>
                                    </a-button>
                                </EmployeeSelector>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="互访日期">
                            <a-date-picker
                                    placeholder=""
                                    v-decorator="[
                  'visitDate',
                ]"
                                    style="width: 100%"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row style="margin-top: 20px;">
                    <a-col :lg="18" :md="18" :sm="24" offset="4">
                        <a-table
                                bordered
                                :data-source="amountList"
                                :pagination='false'
                        >
                            <a-table-column title="合同签订年份" data-index="year" />
                            <a-table-column title="合同总金额(万元)" data-index="amount" />
                            <a-table-column title="">
                                <template slot-scope="text">
                                    <a-icon v-if="text.amount>=800" type="check-circle" style="color: rgb(82, 196, 26)" />
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-col>
                </a-row>
                <div class="center">
                    <a-space>
                        <a-button @click="$close($route.path)">关闭</a-button>
                        <a-button type="primary" html-type="submit" :loading="saveLoading">提交</a-button>
                    </a-space>
                </div>
                <!-- 把你原来的区域分布 替换成这段 -->
                <div class="region-desc">
                    <div class="title">区域分布：</div>
                    <div class="item">
                        <span>经营一组（杨小平）：</span>
                        <p>集团总部；南京【玄武区、秦淮区、建邺区、鼓楼区、栖霞区、雨花台区、江宁区、溧水区、高淳区、江北新区】；泰州【市本级、海陵区、高港区、姜堰区】。</p>
                    </div>
                    <div class="item">
                        <span>经营二组（燕强）：</span>
                        <p>集团西部大区、集团东部大区、集团南部大区；无锡【锡山区、滨湖区】；盐城【滨海县、阜宁县】。</p>
                    </div>
                    <div class="item">
                        <span>经营三组（任云）：</span>
                        <p>苏州【常熟市、张家港市、昆山市】；南通【通州区】；连云港【灌南县】；淮安【市本级、淮安区、盱眙县、金湖县】；盐城【射阳县、建湖县】；扬州【宝应县】；镇江【句容市】；泰州【兴化市、靖江市、泰兴市】；宿迁【宿城区、泗洪县】。</p>
                    </div>
                    <div class="item">
                        <span>经营四组（王威）：</span>
                        <p>省环保产业股份有限公司、湖北黄冈；徐州【睢宁县】；连云港【东海县】；淮安【涟水县】；镇江【丹阳市】。</p>
                    </div>
                    <div class="item">
                        <span>经营五组（沈巍）：</span>
                        <p>南京【市本级】；无锡【惠山区、梁溪区、江阴市、宜兴市】；徐州【鼓楼区、贾汪区、泉山区、丰县、沛县、邳州市】；苏州【相城区、吴江区、太仓市】；连云港【市本级、海州区、赣榆区、灌云县】；盐城【响水县】；扬州【市本级、仪征市】；镇江【市本级、京口区、润州区】；宿迁【市本级】。</p>
                    </div>
                    <div class="item">
                        <span>经营六组（孙鹏）：</span>
                        <p>海外、集团北部大区；徐州【市本级】。</p>
                    </div>
                    <div class="item">
                        <span>经营七组（袁忠伟）：</span>
                        <p>葛洲坝集团、江苏省环保集团（产业公司除外）；常州【市本级、溧阳市】；南通【市本级、崇川区、海门区、如东县、启东市、如皋市、海安市】；淮安【淮阴区、洪泽区】；盐城【市本级、亭湖区、盐都区、大丰区、东台市】；扬州【高邮市】；镇江【丹徒区】；宿迁【宿豫区、泗阳县、开发区】。</p>
                    </div>
                    <div class="item">
                        <span>经营八组（黄晓东）：</span>
                        <p>安徽池州、安徽宿州；南京【六合区】。</p>
                    </div>
                </div>
            </a-form>
        </a-card>
    </div>
</template>

<script>
import city from "@/mixins/city";
import area from "@/mixins/area";
import organization from "@/mixins/organization";
import watermark from "@/mixins/watermark";

import { mapGetters } from "vuex";

import EmployeeSelector from "@/components/employee-selector";
import CompanySelector from "@/components/company-selector";

import accurate from "accurate";

import request from "@/api/request";

function add(data) {
    return request({
        url: "/market-service/scrm/exclusive/area/add",
        method: "post",
        data
    });
}
function update(data) {
    return request({
        url: "/market-service/scrm/exclusive/area/updateForReview",
        method: "post",
        data
    });
}

function getAmountList(params) {
    return request({
        url: "/market-service//scrm/exclusive/area/contractAmount/year",
        params
    });
}
function getAreaDetail(id) {
    return request({
        url: "/market-service//scrm/exclusive/area/query/" + id,
    });
}

export default {
    mixins: [area, city, organization, watermark],

    components: {
        EmployeeSelector,
        CompanySelector
    },

    data() {
        return {
            form: this.$form.createForm(this),
            selectedUser: {},
            selectedCompany: {},
            saveLoading: false,
            chargeUser: {},
            businessUser: {},
            technologyUser: {},
            visitLeader: {},
            belongProvince: '',
            belongCity: '',
            district: '',
            deptId: '',
            amountList: [],
            ifEdit: false,
        };
    },

    computed: {
        ...mapGetters("setting", ["findDataDict"]),

        phaseList() {
            return this.findDataDict("phase");
        },
        signStatusList() {
            return this.findDataDict("contractSignStatus");
        },

        majorList() {
            return this.findDataDict("contract_scale");
        }
    },
    mounted() {
        const id = this.$route.query.id;
        if(id){
            this.ifEdit = true;
            getAreaDetail(id).then(res => {
                const area = [];
                if (res.areaId) {
                    area.push(res.areaId);
                }
                if (res.subAreaId) {
                    area.push(res.subAreaId);
                }
                if (res.l3AreaId) {
                    area.push(res.l3AreaId);
                }

                this.form.setFieldsValue({
                    ...res,
                    customerRelationship: res.customerRelationship.split(","),
                    location: [res.belongProvince, res.belongCity, res.district],
                    area: area,
                });
                this.deptId = res.deptId;
                this.belongProvince = res.belongProvince;
                this.belongCity = res.belongCity;
                this.district = res.district;
                this.amountList = res.contractAmountYearList;
                this.chargeUser = {
                    name: res.chargeUserName,
                    userId: res.chargeUserId
                };
                this.businessUser = {
                    name: res.businessUserName,
                    userId: res.businessUserId
                };
                this.technologyUser = {
                    name: res.technologyUserName,
                    userId: res.technologyUserId
                };
                this.visitLeader = {
                    name: res.visitLeaderName,
                    userId: res.visitLeaderId
                };
            })
        }
    },
    methods: {
        chargerChange(arr) {
            console.log(arr)
            if (arr.length) {
                this.chargeUser = arr[0];
                this.form.setFieldsValue({
                    deptId: arr[0].deptId
                });
                this.deptId = arr[0].deptId,
                    this.getList();
            }else {
                this.chargeUser = {};
            }

        },
        locationChange(arr){
            this.belongProvince = arr[0];
            this.belongCity = arr[1];
            this.district = arr[2];
            this.getList();
        },
        getList(){
            if(this.district && this.chargeUser.userId){
                getAmountList({deptId: this.deptId,belongCity: this.belongCity,belongProvince: this.belongProvince,district: this.district}).then(res => {
                    this.amountList = res
                })
            }else{
                this.amountList = []
            }
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    if (!this.chargeUser.userId) {
                        this.$message.error("请选择主要负责人");
                        return;
                    }
                    if (!this.businessUser.userId) {
                        this.$message.error("请选择商务对接人");
                        return;
                    }
                    if (!this.technologyUser.userId) {
                        this.$message.error("请选择技术对接人");
                        return;
                    }
                    const hasAmount = this.amountList.filter(item => item.amount).length > 0;
                    if (!hasAmount && values.deptId !== "1221129849550213120") {
                        this.$message.error("请选择有签约成绩的区域。");
                        return;
                    }
                    this.save(values);
                }
            });
        },

        save(values) {
            this.saveLoading = true;

            let area1 = {};
            let area2 = {};
            let area3 = {};

            if (Array.isArray(values.area)) {
                const [areaId1, areaId2, areaId3] = values.area;
                area1 = this.rawAreaList.find((item) => item.id === areaId1);
                area2 = this.rawAreaList.find((item) => item.id === areaId2);
                area3 = this.rawAreaList.find((item) => item.id === areaId3);
            }

            if(this.ifEdit){
                update({
                    ...values,
                    areaId: area1?.id,
                    areaName: area1?.areaName,
                    subAreaId: area2?.id,
                    subAreaName: area2?.areaName,
                    l3AreaId: area3?.id,
                    l3AreaName: area3?.areaName,
                    belongProvince:this.belongProvince,
                    belongCity:this.belongCity,
                    district:this.district,
                    customerRelationship: values.customerRelationship ? values.customerRelationship.join(",") : '',
                    deptName: this.productionDepartmentList.find(
                        item => item.id === values.deptId
                    )?.uniqueName,
                    chargeUserId: this.chargeUser.userId,
                    chargeUserName: this.chargeUser.name,
                    businessUserId: this.businessUser.userId,
                    businessUserName: this.businessUser.name,
                    technologyUserId: this.technologyUser.userId,
                    technologyUserName: this.technologyUser.name,
                    visitLeaderId: this.visitLeader.userId,
                    visitLeaderName: this.visitLeader.name,
                    contractAmountYearList: this.amountList,
                    id: this.$route.query.id
                })
                    .then(() => {
                        this.$close(this.$route.path);
                    })
                    .finally(() => {
                        this.saveLoading = false;
                    });
            }else{
                add({
                    ...values,
                    areaId: area1?.id,
                    areaName: area1?.areaName,
                    subAreaId: area2?.id,
                    subAreaName: area2?.areaName,
                    l3AreaId: area3?.id,
                    l3AreaName: area3?.areaName,
                    belongProvince:this.belongProvince,
                    belongCity:this.belongCity,
                    district:this.district,
                    customerRelationship: values.customerRelationship ? values.customerRelationship.join(",") : '',
                    deptName: this.productionDepartmentList.find(
                        item => item.id === values.deptId
                    )?.uniqueName,
                    chargeUserId: this.chargeUser.userId,
                    chargeUserName: this.chargeUser.name,
                    businessUserId: this.businessUser.userId,
                    businessUserName: this.businessUser.name,
                    technologyUserId: this.technologyUser.userId,
                    technologyUserName: this.technologyUser.name,
                    visitLeaderId: this.visitLeader.userId,
                    visitLeaderName: this.visitLeader.name,
                    contractAmountYearList: this.amountList
                })
                    .then(() => {
                        this.$close(this.$route.path);
                    })
                    .finally(() => {
                        this.saveLoading = false;
                    });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 24px;
}

.center {
  padding: 30px 0;
}
/* 区域分布美化样式 */
.region-desc {
    padding: 16px 20px;
    background: #f9fafc;
    border-radius: 8px;
    border: 1px solid #e5e6eb;
    line-height: 1.7;
    width: 85%;
    margin:auto;
    .title {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
    }

    .item {
        margin-bottom: 10px;
        display: flex;
        align-items: flex-start;

        span {
            min-width: 130px;
            font-weight: 500;
            color: #000;
            flex-shrink: 0;
        }

        p {
            margin: 0;
            color: #555;
            flex: 1;
        }
    }
}
</style>
